module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Bradford",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRADFORD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Gateshead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GATESHEAD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Hull",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HULL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Leeds",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEEDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Newcastle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEWCASTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Rotherham",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROTHERHAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sheffield",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHEFFIELD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_South_Shields",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOUTH SHIELDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_South_Yorkshire_Supertram",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOUTH YORKSHIRE SUPERTRAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Sunderland",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDERLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Tyne_Wear_Metro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TYNE & WEAR METRO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Preservation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRESERVATION")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0